$(document).ready(function() {
  // Slick args
  let centeredArgs = {
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    infinite:true,
    arrows: true, 
    nextArrow: '',
    prevArrow: '',// Add the beforeChange event to check if the next slide is a placeholder
   
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  }

  let fauxCart = {
    items: [],
    totalOriginalPrice: 0,
    totalDiscountedPrice: 0,
    updateTotals: function () {
      var discountValue = parseFloat($('#discountValue').data('discount'));
  
      this.totalOriginalPrice = 0;
      this.totalDiscountedPrice = 0;
      
      // Classname first-row-only is applied when collection.metafields.custom.only_show_bundle_discount_on_first_row is true
      let discountFirstRowOnly = $('.faux-cart__body').hasClass('first-row-only'); 

      this.items.forEach((item, index) => {
          if (!item.hidden) {
              this.totalOriginalPrice += item.originalPrice;
  
              let discount = 0;
              let discountedPrice = item.originalPrice;
  
              if (discountFirstRowOnly) { // Only shows / applies discount on the first row item.
                  if (index === 0) {
                      discount = item.originalPrice * discountValue / 100;
                      discountedPrice = item.originalPrice - discount;
                      this.totalDiscountedPrice += discountedPrice; 
                  } else { 
                      this.totalDiscountedPrice += item.originalPrice// no discount 
                  }
              } else {
                // Regular discount function where discount applies to all rows of products
                  discount = item.originalPrice * discountValue / 100;
                  discountedPrice = item.originalPrice - discount;
                  this.totalDiscountedPrice += discountedPrice;
              }
  
              // Save calculated value for future reference
              item.discountedPrice = discountedPrice;
  
              // Update DOM
              let fauxCartItem = $('.faux-cart__body .product-card').eq(index);
              let mobileFauxCartItem = $('.mobile-cart__items .mobile-cart__item').eq(index);
  
              fauxCartItem.find('.product-price-discount').text(`$${discountedPrice.toFixed(2)}`);
              mobileFauxCartItem.find('.product-price-discount').text(`$${discountedPrice.toFixed(2)}`);
          }
      });
  
      const isDesktopView = $(window).width() >= 769;
      const $totalPriceOrig = isDesktopView ? $('.faux-cart .total-price-orig') : $('.mobile-cart .total-price-orig, .mobile-go-button .total-price-orig');
      const $totalPriceDiscount = isDesktopView ? $('.faux-cart .total-price-discount') : $('.mobile-cart .total-price-discount, .mobile-go-button .total-price-discount');
  
      if (this.totalOriginalPrice === this.totalDiscountedPrice) {
          $totalPriceOrig.hide();
      } else {
          $totalPriceOrig.text(`$${this.totalOriginalPrice.toFixed(2)}`).show();
      }
  
      $totalPriceDiscount.text(`$${this.totalDiscountedPrice.toFixed(2)}`);
  },
  
    updateCartItem: function (index, productData) {  
        let item = this.items[index];
      
        if (!item) {
            item = { hidden: true };
            this.items[index] = item;
        }

        item.productId = productData.productId;
        // Safely handle productPrice - check if it exists and is a string before calling replace
        const productPriceStr = productData.productPrice ? String(productData.productPrice) : '0';
        item.originalPrice = parseFloat(productPriceStr.replace('$', '').replace(',', '')) || 0;
        // Safely handle productSalePrice - check if it exists and is a string before calling replace
        const productSalePriceStr = productData.productSalePrice ? String(productData.productSalePrice) : productPriceStr;
        item.discountedPrice = parseFloat(productSalePriceStr.replace('$', '').replace(',', '')) || item.originalPrice;
        item.hidden = !(productData.productTitle && productData.productPrice);
        if(productData.preorderMsg){
          item.properties = (productData.preorderMsg); 
        }else if(productData.isfinalsale){
          item.properties = (productData.isfinalsale); 
        }

        let fauxCartItem = $('.faux-cart__body .product-card').eq(index);
        fauxCartItem.attr('data-product-id', productData.productId);

        let mobileFauxCartItem = $('.mobile-cart__items .mobile-cart__item').eq(index);
        mobileFauxCartItem.attr('data-product-id', productData.productId);

        if (!item.hidden) {
          fauxCartItem.find('.product-title').text(productData.productTitle);
          fauxCartItem.find('.product-price').text(productData.productPrice);
          fauxCartItem.find('.product-price-discount').text(productData.productSalePrice);
          fauxCartItem.find('.product-color').text(productData.productColor); 
          if(productData.preorderMsg){
            fauxCartItem.find('.product__meta-tag').text(productData.preorderMsg); 
          }else if(productData.isfinalsale){ 
            fauxCartItem.find('.product__meta-tag').text(productData.isfinalsale); 
          }else{ 
            fauxCartItem.find('.product__meta-tag').text(''); 
            fauxCartItem.find('.product__meta-tag').text(''); 
          }
          fauxCartItem.find('.product-image').attr('src', productData.productImage);
          fauxCartItem.removeClass('hidden');
          mobileFauxCartItem.find('.mobile-cart__name').text(productData.productTitle);
          mobileFauxCartItem.find('.product-price').text(productData.productPrice);
          mobileFauxCartItem.find('.product-price-discount').text(productData.productSalePrice);
          mobileFauxCartItem.find('.product-color').text(productData.productColor);
          mobileFauxCartItem.find('.mobile-cart__image').attr('src', productData.productImage);
          mobileFauxCartItem.removeClass('hidden');
        } else {
            fauxCartItem.addClass('hidden');
        }
        this.updateTotals();
    }
};

  let resizeTimer;
  $(window).resize(function() {
      if (resizeTimer) {
          cancelAnimationFrame(resizeTimer);
      }
      // resizeTimer = requestAnimationFrame(fauxCart.updateTotals);
  });

// Convert price string to a floating-point number
parsePrice = function(priceStr) {

  return parseFloat(priceStr.replace(/[^\d\.]/g, ''));
}

  function updateFauxCartOnSlide(carouselIndex, activeSlide) { 
    if ($(activeSlide).hasClass('placeholder')) { 
      return; // Do nothing if it's a placeholder
      // Placeholder grid items are only used in carousels with less than 4 items, to allow Slick to scroll 
      // even when there are not enough true product items to scroll through within the 3-across layout.
  }
    
    // activeSlide should always be a grid item, so just look for the active swatch within it
    let activeSwatch = $(activeSlide).find('.color-swatch.active-swatch');
    let productData;
    
    if (activeSwatch.length > 0) {
      // Use the data from the active swatch - this is always the most current variant
      let swatchContainer = activeSwatch.closest('.color-swatch-container');
      productData = {
        productPrice: swatchContainer.attr('data-product-price'),
        productSalePrice: String(swatchContainer.attr('data-product-sale-price')),
        productColor: swatchContainer.attr('data-color'),
        productHandle: swatchContainer.attr('data-product-handle'),
        productId: swatchContainer.attr('data-product-id'),
        productTitle: swatchContainer.attr('data-product-title'),
        productImage: swatchContainer.attr('data-fauxcartsrcset'),
        preorderMsg: swatchContainer.attr('data-preorder-msg'),
        isfinalsale: swatchContainer.attr('data-finalsale-msg')
      };
    } else {
      // Fallback to grid item data if no active swatch
      productData = {
        productPrice: $(activeSlide).attr('data-product-price'),
        productSalePrice: String($(activeSlide).attr('data-product-sale-price')),
        productColor: $(activeSlide).attr('data-product-color') || $(activeSlide).attr('data-color'),
        productHandle: $(activeSlide).attr('data-product-handle'),
        productId: $(activeSlide).attr('data-product-id'),
        productTitle: $(activeSlide).attr('data-product-title'),
        productImage: $(activeSlide).attr('data-product-image'),
        preorderMsg: $(activeSlide).attr('data-preorder-msg'),
        isfinalsale: $(activeSlide).attr('data-finalsale-msg')
      };
    }
    
    fauxCart.updateCartItem(carouselIndex, productData);
}

  // Update the faux cart based on the QV
  function updateFauxCartOnQV(carouselIndex, swatch) {
    let productData = {
        productId: swatch.data('product-id'),
        productPrice: swatch.data('product-price'),
        productSalePrice: String(swatch.data('product-sale-price')),
        productColor: swatch.find('.color-swatch-color-name').text(),
        productHandle: swatch.data('product-handle'), 
        productTitle: swatch.data('product-title'),
        productImage: swatch.data('fauxcartsrcset')
    };
    fauxCart.updateCartItem(carouselIndex, productData);
}

function updateBadges(gridSwatchesContainer, preorderMessage, customMessage, finalSaleMessage) {
  // Determine the template based on the existing classes
  let goTemplateCopy = document.querySelector('.go-collection-copy') ? true : false;
  let goTemplate = document.querySelector('.go-collection') ? true : false;

  // Function to remove any existing badges
  function removeExistingBadges() { 
    let existingPreorderBadge = gridSwatchesContainer[0].parentNode.querySelector('.pdp-details-preorder');
    let existingCustomBadge = gridSwatchesContainer[0].parentNode.querySelector('.free-note-inner');
    let existingFinalSaleBadge = gridSwatchesContainer[0].parentNode.querySelector('.finalsale');
  
    if (existingPreorderBadge) existingPreorderBadge.remove();
    if (existingCustomBadge) existingCustomBadge.remove();
    if (existingFinalSaleBadge) existingFinalSaleBadge.remove();
  }

  // Function to create and append a badge
  function createBadge(message, badgeClass) {
    let divElement = document.createElement('div');
  
    // Create the span element
    let badgeElement = document.createElement('span');
    badgeElement.classList.add(...badgeClass);
    badgeElement.innerHTML = message;
  
    // Append the span inside the div
    divElement.appendChild(badgeElement);
  
    // Append the div to the parent container
    gridSwatchesContainer[0].parentNode.appendChild(divElement);
  }

  // Remove existing badges before rendering new ones
  removeExistingBadges();

  // Construct the appropriate class names for each badge type
  let preorderBadgeClass = goTemplate ? ['go-badge-style', 'pdp-details-preorder', 'product__meta-tag'] : 
                                        goTemplateCopy ? ['go-badge-copy', 'pdp-details-preorder', 'product__meta-tag'] : 
                                        [];
  let customBadgeClass = goTemplate ? ['go-badge-style', 'free-note-inner', 'product__meta-tag'] : 
                                      goTemplateCopy ? ['go-badge-copy', 'free-note-inner', 'product__meta-tag'] : 
                                      [];
  let finalSaleBadgeClass = goTemplate ? ['go-badge-style', 'finalsale', 'product__meta-tag'] : 
                                         goTemplateCopy ? ['go-badge-copy', 'finalsale', 'product__meta-tag'] : 
                                         [];

  // Render the badges based on the priority:
  // 1. Always show preorder badge if it exists
  if (preorderMessage) {
    createBadge(preorderMessage, preorderBadgeClass);
  }

  // 2. Show custom message if it exists, otherwise show final sale message
  if (customMessage) {
    createBadge(customMessage, customBadgeClass);
  } else if (finalSaleMessage) {
    createBadge(finalSaleMessage, finalSaleBadgeClass);
  }
}



// Primary swatch click function
    handleSwatchClickRefactor = function(swatchEl, isQuickview) {
      // Defensive: Validate swatchEl exists and has required data
      if (!swatchEl || !$(swatchEl).length || !$(swatchEl).attr('data-color')) {
        return;
      }

      // Primary Els and Values
      let thisSwatch = $(swatchEl).find('.color-swatch');
      let thisSwatchValue = $(swatchEl).attr('data-color');
      let swatchProdHandle = $(swatchEl).attr('data-product-handle');
      // let swatchProdHandle;
      let relatedSwatches;
      let ancestorTrack;
      let rowQV;
      let gridSwatch; 
      let qvSwatchWrapper;
      let qvSwatches;
      if(isQuickview){
        let quickviewModal = $(swatchEl).closest('.hobo-go-plp__quickview-container');
        ancestorTrack = $(quickviewModal).siblings('.go-carousel');
        relatedSwatches = ancestorTrack.find('.color-swatch-container');
        rowQV = ancestorTrack.siblings('.hobo-go-plp__quickview-container');
        gridSwatch = ancestorTrack.find(`.color-swatch-container[data-product-handle="${swatchProdHandle}"`);
        qvSwatchWrapper = thisSwatch.closest('.swatches-wrapper')
      }else{
        gridSwatch = swatchEl;
        ancestorTrack = $(swatchEl).closest('.go-carousel');
        rowQV = ancestorTrack.siblings('.hobo-go-plp__quickview-container');
        qvSwatchWrapper = rowQV.find('.swatches-wrapper')
        relatedSwatches = rowQV.find('.color-swatch-container');
        qvSwatches = rowQV.find('.swatches-wrapper')
      }
      let ancestorGridItem = $(gridSwatch).closest('.grid__item');
      let gridItemSwatchlabel = ancestorGridItem.find('.label.current_color');
      let gridProdHandle = ancestorGridItem.attr('data-product-handle');
      let srcSet = $(gridSwatch).attr('data-srcset');
      let hoverSrcSet = $(gridSwatch).attr('data-hoversrcset');
      let thirdSrcSet = $(gridSwatch).attr('data-thirdsrcset');
      let fourthSrcSet = $(gridSwatch).attr('data-fourthsrcset');
      let fauxCartSrcSet = $(gridSwatch).attr('data-fauxcartsrcset');
      let prodId = $(gridSwatch).attr('data-product-id');
      let prodHandle = $(gridSwatch).attr('data-product-handle');
      let prodURL = $(gridSwatch).attr('data-product-url');
      let prodTitle = $(gridSwatch).attr('data-product-title');
      let prodDesc = ancestorGridItem.find('.description p').text();
      let productImages = $(gridSwatch).closest('.grid-product__content');
      let productPrice = $(gridSwatch).attr('data-product-price');
      let productSalePrice = $(gridSwatch).attr('data-product-sale-price');
      let preorder_badge = $(gridSwatch).attr('data-preorder-msg');
      let final_sale = $(gridSwatch).attr('data-finalsale-msg');
      let custom_msg = $(gridSwatch).attr('data-freenote-msg');
  

      // Grid Item Secondary Els and Values
      let productLink = productImages.find('.grid-product__link');
      let productTitleLink = ancestorGridItem.find('.title-container');
      let primaryImage = productImages.find('.grid-product__image');
      let hoverImage = productImages.find('.grid-product__secondary-image img');
      let parsedColor = thisSwatchValue.replace(/-/g, " ");

      // QuickView Secondary Els and Values
      let quickViewTitle = rowQV.find('.hobo-go-plp__prod-title span');
      let quickViewLink = rowQV.find('.hobo-go-plp__prod-title a');
      let quickViewDesc = rowQV.find('.hobo-go-plp__prod-desc-copy');
      let quickViewPriceCon = rowQV.find('.hobo-go-plp__prod-price');
      let quickViewImgCon = rowQV.find('.hobo-go-plp__quickview-images');
      let quickViewImgThumbs = rowQV.find('.hobo-go-plp__quickview-image-thumbs');

      // Check if clicked swatch is already the active swatch
      if (thisSwatch.hasClass('active-swatch')) {
        return
      } else {
        if(ancestorGridItem.hasClass('slick-current') || isQuickview){
          let rowId = ancestorTrack.data('row-id'); // This gets the data attribute value
          // Parse the string to an integer
          let numericRowId = parseInt(rowId, 10);
          // Subtract 1 from the parsed integer
          let updatedRowId = numericRowId - 1;
          updateFauxCartOnSlide(updatedRowId,$(swatchEl))

          // Remove active class from swatches
          let gridSwatchesContainer = $(gridSwatch).closest('.swatches-wrapper');
          let gridSwatches = gridSwatchesContainer.find('.color-swatch');

          if (gridSwatches.length > 0) {
            gridSwatches.each(function() {
              if($(this).hasClass('active-swatch')) {
                $(this).removeClass('active-swatch');
              }
            })
          }
          // Remove active class from swatches
          let qvSwatches = qvSwatchWrapper.find('.color-swatch');

          if (qvSwatches.length > 0) {
            qvSwatches.each(function() {
              if($(this).hasClass('active-swatch')) {
                $(this).removeClass('active-swatch');
              }
            })
          }
          // Add active class to clicked swatch on grid item
          thisSwatch.addClass('active-swatch');
          // Add active class to clicked swatch on QV
          if (relatedSwatches.length > 0) {
            relatedSwatches.each(function() {

              let color = $(this).attr('data-color');      
              if(color == thisSwatchValue) {
                $(this).find('.color-swatch').addClass('active-swatch');
              } else {
                $(this).find('.color-swatch').removeClass('active-swatch');
              }
            })
          }

          let numProductSalePrice = parsePrice(productSalePrice);
          let numProductPrice = parsePrice(productPrice);
          let content

          if (numProductSalePrice > 0 && numProductSalePrice < numProductPrice) {
            content = `<div class="grid-product__price"><span class="visually-hidden">Regular price</span>` +
              `<span class="grid-product__price--original">${productPrice}</span>` +
              `<span class="visually-hidden">Sale price</span>${productSalePrice}</div>`;
            let priceContainer = ancestorGridItem.find('.grid-product__price');
            priceContainer.html(content);
          } else {
            content = `<div class="grid-product__price">${productPrice}</div>`;
            let priceContainer = ancestorGridItem.find('.grid-product__price');
            priceContainer.html(content);
          }

          // Update badges depending on what messages exist
          // Priority is: 1) preorder 2) custom message 3) final sale 
          updateBadges(gridSwatchesContainer, preorder_badge, custom_msg, final_sale);


          // Update grid image if they exist
          if (primaryImage.length && hoverImage.length) {
            primaryImage.attr('srcset', srcSet);
            primaryImage.attr('data-srcset', srcSet);
            hoverImage.attr('srcset', hoverSrcSet);
            hoverImage.attr('data-srcset', hoverSrcSet);
            productLink.attr('href', prodURL);
            productLink.attr('title', prodTitle);
            productTitleLink.attr('href', prodURL);
            gridItemSwatchlabel.text(parsedColor);

            // update grid items root values use by fauxcart js
            ancestorGridItem.attr('data-product-id', prodId);
            ancestorGridItem.attr('data-product-color', parsedColor);
            ancestorGridItem.attr('data-product-image', fauxCartSrcSet);
            ancestorGridItem.attr('data-product-price', productPrice);
            ancestorGridItem.attr('data-product-sale-price', productSalePrice);

            // Slick makes duplicate grid items for smooth scrolling so this checks if duplicates exist and also updates them. 
            // Without this slider shows strange behavior due to placement of duplicates and originals along track.
            let hasMatchingHandle = ancestorTrack.find('.grid__item[data-product-handle="' + gridProdHandle + '"]');

            if (hasMatchingHandle.length > 0) {
              hasMatchingHandle.each(function() {
                let colorLabel = $(this).find('.label.current_color');
                let productImages = $(this).find('.grid-product__content');    

                let matchProductLink = productImages.find('.grid-product__link');
                let matchPrimaryImage = productImages.find('.grid-product__image');
                let matchHoverImage = productImages.find('.grid-product__secondary-image img');

                $(this).attr('data-product-id', prodId);
                $(this).attr('data-product-color', parsedColor);
                $(this).attr('data-product-image', fauxCartSrcSet);
                $(this).attr('data-product-price', productPrice);
                $(this).attr('data-product-sale-price', productSalePrice);

                matchPrimaryImage.attr('srcset', srcSet);
                matchPrimaryImage.attr('data-srcset', srcSet);
                matchHoverImage.attr('srcset', hoverSrcSet);
                matchHoverImage.attr('data-srcset', hoverSrcSet);
                matchProductLink.attr('href', prodURL);
                matchProductLink.attr('title', prodTitle);
                colorLabel.text(parsedColor);
              })
            } 
          }
          // Update row QV on swatch click of grid item swatch
          rowQV.attr('data-product-handle', swatchProdHandle);
          rowQV.find('.hobo-go-plp__label-current-color').text(parsedColor);
          quickViewPriceCon.empty();
          quickViewPriceCon.html(content);
          quickViewTitle.text(prodTitle);
          if(quickViewDesc.text() == '' && quickViewDesc.text() == null){
            quickViewDesc.text(prodDesc);
          };
          quickViewLink.attr('href', prodURL);
          quickViewImgCon.find('.image-1').attr('data-src', srcSet);
          quickViewImgCon.find('.image-1').attr('src', srcSet);
          quickViewImgCon.find('.image-2').attr('data-src', hoverSrcSet);
          quickViewImgCon.find('.image-2').attr('src', hoverSrcSet);
          quickViewImgCon.find('.image-3').attr('data-src', thirdSrcSet);
          quickViewImgCon.find('.image-3').attr('src', thirdSrcSet);
          quickViewImgCon.find('.image-4').attr('data-src', fourthSrcSet);
          quickViewImgCon.find('.image-4').attr('src', fourthSrcSet);
          
          quickViewImgThumbs.find('.image-1').attr('data-src', srcSet);
          quickViewImgThumbs.find('.image-1').attr('src', srcSet);
          quickViewImgThumbs.find('.image-2').attr('data-src', hoverSrcSet);
          quickViewImgThumbs.find('.image-2').attr('src', hoverSrcSet);
          quickViewImgThumbs.find('.image-3').attr('data-src', thirdSrcSet);
          quickViewImgThumbs.find('.image-3').attr('src', thirdSrcSet);
          quickViewImgThumbs.find('.image-4').attr('data-src', fourthSrcSet);
          quickViewImgThumbs.find('.image-4').attr('src', fourthSrcSet);
        }
      }
    }




  // QuickView Content Load Function
  loadQuickViewContent = function(event, slick, currentSlide, rowID) {
    let slideIndex = currentSlide;
    let row = $('#go-row-' + rowID);
    let currentSlideEl = row.find('.grid__item[data-slick-index="' + slideIndex + '"]');

    // Defensive: Return early if slide element not found
    if (!currentSlideEl.length) {
      return;
    }

    let prodTitle = currentSlideEl.find('.title').text();
    let prodDesc = currentSlideEl.find('.description').text();
    let prodLink = currentSlideEl.find('.grid-product__link').attr('href');
    let prodHandle = currentSlideEl.attr('data-product-handle');
    let prodFeatures = currentSlideEl.find('.sib-features').clone()
    let swatches = currentSlideEl.find('.color-swatch-container');
    let prefix = currentSlideEl.find('.color-swatch-container').attr('data-product-color-prefix')
    let prodPriceContainer = currentSlideEl.find('.grid-product__price');
    let priceSpans = [];
    if (prodPriceContainer.children('span').length > 0) {
      priceSpans = prodPriceContainer.find('span');
    }

    let imgSpans = currentSlideEl.find('.go-quick-image');
    let swatchesArr = []

    // Defensive: Handle products with no swatches or single swatch gracefully
    if (swatches.length > 0) {
      swatches.each(function() {
        let wrapperDiv = $('<div>').append($(this).clone());
        swatchesArr.push(wrapperDiv.html());
      });
    }

    // Gets containers where data needs to be rendered
    let carouselQuickView = row.siblings('.hobo-go-plp__quickview-container');
    let quickViewTitle = carouselQuickView.find('.hobo-go-plp__prod-title span');
    let quickViewLink = carouselQuickView.find('.hobo-go-plp__prod-title a');
    let quickViewDesc = carouselQuickView.find('.hobo-go-plp__prod-desc-copy');
    let quickViewPrice = carouselQuickView.find('.hobo-go-plp__prod-price');
    let quickViewFeatures = carouselQuickView.find('.hobo-go-plp__prod-features')
    let quickViewImgCon = carouselQuickView.find('.hobo-go-plp__quickview-images');
    let quickViewImgThumbCon = carouselQuickView.find('.hobo-go-plp__quickview-image-thumbs');
    let quickViewSwatchCon = carouselQuickView.find('.hobo-go-plp__prod-var-swatches');
    let quickViewSwatchLabel = carouselQuickView.find('.hobo-go-plp__label-current-color');
    let quickViewColorPrefix = carouselQuickView.find('.hobo-go-plp__label-prefix');

    // Appends data to relevant quickview container elements
    carouselQuickView.attr('data-product-handle', prodHandle);
    quickViewTitle.text(prodTitle);
    quickViewDesc.text(prodDesc);
    quickViewLink.attr('href', prodLink);
    quickViewFeatures.empty()
    prodFeatures.appendTo(quickViewFeatures) // Appends product features to quickview container
    quickViewSwatchCon.empty();

    // Defensive: Only append swatches if they exist
    if (swatchesArr.length > 0) {
      swatchesArr.forEach(function(value) {
        quickViewSwatchCon.append(value);
      });
    }

    let relatedSwatches = quickViewSwatchCon.find('.color-swatch-container');

    // BUGFIX: Unbind old click handlers before binding new ones to prevent memory leak
    // Each swipe was adding duplicate handlers, causing performance degradation
    relatedSwatches.off('click');

    // Defensive: Only bind click handlers if swatches exist
    if (relatedSwatches.length > 0) {
      relatedSwatches.each(function(){
        $(this).on('click', function(){
          let $this = $(this)[0]
          handleSwatchClickRefactor($this, true)
        })
      })
    }

    // Defensive: Only set prefix if it exists
    if(quickViewColorPrefix && prefix){
      quickViewColorPrefix.text(`${prefix}:  `)
    }

    let activeSwatchColor = quickViewSwatchCon.find('.active-swatch').closest('.color-swatch-container').attr('data-color');

    if(activeSwatchColor != undefined) {
      activeSwatchColor = activeSwatchColor.replace(/-/g, " ");
      quickViewSwatchLabel.text(activeSwatchColor);
    }

    quickViewPrice.empty();

    if (priceSpans.length > 0) {
      priceSpans.each(function() {
        let clonedSpan = $(this).clone();
        quickViewPrice.append(clonedSpan);
      });
    } else {
      let priceSpan = $('<span>');
      let price = prodPriceContainer.text();
      priceSpan.text(price);
      quickViewPrice.append(priceSpan);
    }

    quickViewImgCon.empty();
    quickViewImgThumbCon.empty();

    // Defensive: Only process images if they exist
    if (imgSpans.length > 0) {
      let loopIndex = 1;
      imgSpans.each(function() {
        let srcSet = $(this).data('src');
        let aspectRatio = $(this).data('aspectratio');
        let alt = $(this).attr('alt');

        // Defensive: Skip if srcSet is missing or invalid
        if (!srcSet || srcSet.includes('no-image')) {
          return true; // Continue to next iteration
        }

        let quickViewImage = $('<img>');
        quickViewImage.attr('data-src', srcSet);
        quickViewImage.attr('src', srcSet);
        quickViewImage.attr('alt', alt || '');
        quickViewImage.attr('data-aspectratio', aspectRatio);
        quickViewImage.addClass('quick-view-image');
        quickViewImage.addClass('image-' + loopIndex);

        quickViewImgCon.append(quickViewImage.clone());
        quickViewImgThumbCon.append(quickViewImage.clone());
        loopIndex++
      });
    }
  }

  // Open QuickView Function
  openQuickView = function($this) {

    let carouselWrap = $this.closest('.go-carousel-wrapper');
    let carousel = carouselWrap.find('.go-carousel');
    let quickView = carousel.siblings('.hobo-go-plp__quickview-container');
    let quickViewMediaCarousel = quickView.find('.hobo-go-plp__quickview-images');
    let mediaElID = quickViewMediaCarousel.attr('id');
    let quickViewThumbsCarousel = quickView.find('.hobo-go-plp__quickview-image-thumbs');
    let mediaThumbsID = quickViewThumbsCarousel.attr('id');
    let quickViewOuter = $('<div class="quickview-outer"></div>')
    quickViewOuter.insertAfter(quickView)
    $(quickViewOuter).on('click', function(){
      closeQuickView($(this))
    })
    $('body').css('overflow', 'hidden');
    carouselWrap.addClass('qv-open');
      quickViewMediaCarousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $(quickViewMediaCarousel).siblings('.go-carousel-prev-qvm'),
        nextArrow: $(quickViewMediaCarousel).siblings('.go-carousel-next-qvm'),
        infinite: false,
        autoplay: false,
        arrows: true,
        asNavFor: "#"+mediaThumbsID,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      quickViewThumbsCarousel.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: "#"+mediaElID,
        autoplay: false,
        dots: false,
        centerMode: false,
        infinite: false,
        focusOnSelect: true,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              variableWidth: true
            }
          }
        ]
      })
  }

  // Close Quickview Function
  closeQuickView = function($this) {
    let carousel = $this.closest('.go-carousel-wrapper').find('.go-carousel');
    $('.quickview-outer').remove()
    let quickView = carousel.siblings('.hobo-go-plp__quickview-container');
    let quickViewMediaCarousel = quickView.find('.hobo-go-plp__quickview-images');
    let quickViewThumbsCarousel = quickView.find('.hobo-go-plp__quickview-image-thumbs');

    quickViewMediaCarousel.slick('unslick');
    quickViewThumbsCarousel.slick('unslick');
    $('body').css('overflow', 'unset');
    carousel.closest('.go-carousel-wrapper').removeClass('qv-open');
  }

  // Slick initialization with args and Slick slide event listeners and handlers
  $('.go-carousel').each(function(index) {
    let wrapper = $(this).parent();
    let rowID = $(this).attr('data-row-id');

    // BUGFIX: Create a deep copy of centeredArgs for each carousel to prevent shared state issues
    let carouselArgs = $.extend(true, {}, centeredArgs);
    carouselArgs.nextArrow = wrapper.find('.go-carousel-next');
    carouselArgs.prevArrow = wrapper.find('.go-carousel-prev');
    let itemCount = $(this).find('.grid-product').length;

    // Check if the screen is mobile-sized
    if (window.innerWidth <= 768) {
      carouselArgs.slidesToShow = 1; // Force 1 slide to show on mobile
      carouselArgs.centerMode = false; // Disable centering for a cleaner layout
    } else {
      if(itemCount < 4){
          carouselArgs.slidesToShow = 3; // Visually show 3 slots

          carouselArgs.centerMode = true

          carouselArgs.infinite = false
          // Add placeholders for missing items to ensure 3 slots are always visible
          if (itemCount === 1) {
              // Add two blank placeholder slides for the missing items
              // Set width for each item to 33.33% so they take up 1/3 of the width
              $(this).append('<div class="grid-product placeholder"></div>');
              $(this).append('<div class="grid-product placeholder"></div>');
              $(this).append('<div class="grid-product placeholder"></div>');
              $(this).find('.grid-product').css('width', '33.33%');
          } else if (itemCount === 2) {
            // Set width for each item to 33.33% so they take up 1/3 of the width
              // Add one blank placeholder slide for the missing item
              $(this).append('<div class="grid-product placeholder"></div>');
              $(this).append('<div class="grid-product placeholder"></div>');
              $(this).find('.grid-product').css('width', '33.33%');
          } else if (itemCount === 3) {
              // Add one blank placeholder slide for the missing item
              $(this).append('<div class="grid-product placeholder"></div>');
          }
      }else{

      carouselArgs.centerMode = true
      carouselArgs.slidesToShow = 3;
      } // Ensure both are visible if needed
    }

    $(this).on('init', function(event, slick) {
      let currentSlide = $(this).find('.slick-current').attr('data-slick-index');
      loadQuickViewContent(event, slick, currentSlide, rowID);
      updateFauxCartOnSlide(index, slick.$slides.get(currentSlide));
    });

    $(this).on('afterChange', function(event, slick, currentSlide){
      // BUGFIX: Use requestAnimationFrame to defer DOM manipulation until after Slick finishes its calculations
      // This prevents race conditions where Slick in other carousels is reading dimensions during a forced reflow
      requestAnimationFrame(function() {
        try {
          loadQuickViewContent(event, slick, currentSlide, rowID);
          updateFauxCartOnSlide(index, slick.$slides.get(currentSlide));
        } catch(e) {
          console.error('[Carousel Error] Carousel', index, 'afterChange error:', e);
        }
      });

      // Get the index of the next slide
      let nextSlideIndex = currentSlide + 1;

      // Check if the next slide exists and if it has the 'placeholder' class
      if (nextSlideIndex < slick.slideCount) {
        let nextSlide = $(slick.$slides[nextSlideIndex]);
        // Check if the next slide has the 'placeholder' class
        if (nextSlide.hasClass('placeholder')) {
            // Disable the next arrow

          if(slick.$nextArrow){
            slick.$nextArrow.prop('disabled', true);
          }
        } else {
          if(slick.$nextArrow){
            // Re-enable the next arrow if the next slide is not a placeholder
            slick.$nextArrow.prop('disabled', false);
          }
        }
      }
    });
    $(this).slick(carouselArgs);
  });

  // BUGFIX: Protect carousel 3 from third-party scripts hiding it
  // Tangiblee or other scripts may incorrectly target carousel elements
  let carousel3 = document.getElementById('go-row-3');
  if (carousel3) {
    let observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          let display = carousel3.style.display;
          if (display === 'none') {
            // IMMEDIATELY force it back to visible before Slick collapses
            carousel3.style.display = 'block';
            // Force Slick to recalculate dimensions
            $(carousel3).slick('setPosition');
          }
        }
      });
    });

    observer.observe(carousel3, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  // Ajax Add To Cart for desktop and mobile
  // .faux-cart__submit button
  $('.mobile-cart__atb, .faux-cart__submit button').on('click', function() {  
    $(this).addClass('btn--loading');
    var itemsToAdd = $.map(fauxCart.items, function(item) {
      // Start with a basic object containing id, quantity, and default properties
      var itemToAdd = {
          id: item.productId,
          quantity: 1,
          properties: {
              "_go-bundle-plp": true // Existing property
          }
      };
     // Check if item.properties exists and is not empty
      if (item.properties && item.properties.trim() !== "") {
        let downcased = item.properties.toLowerCase() 
        if(downcased.includes('final sale')){

          // Add item properties to the properties object
          itemToAdd.properties.ITEM = item.properties; // Add item.properties as item
        }else if(downcased.includes('preorder') || downcased.includes('pre-order')){
          // Remove "preorder" and "pre-order" by splitting and joining
          
          const wordsToRemove = ["preorder", "pre-order"];
              
          // Iterate through each word to remove and replace it with an empty string
          wordsToRemove.forEach(word => {
            downcased = downcased.split(word).join('');
          }); 
          // Add item properties to the properties object
          itemToAdd.properties.PRE_ORDER = downcased; // Add item.properties as item
        }
      }
      return itemToAdd; // Return the modified item
      }); 
    // Add items to Shopify cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd }),
    })
    .then(response => response.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent ('cart:open'));

    })
    .catch((error) => {
      document.addEventListener('ajaxProduct:error', function(evt) {
        console.log(evt.detail.errorMessage);
      });
    })
    .finally(() => {
      $(this).removeClass('btn--loading');
      
    });
  });

  // Grid Item Swatch click event listener and handler - to be refactored later
  $('.grid__item .color-swatch-container').each(function() {
    $(this).on('click', function() {
      let $this = $(this)
      handleSwatchClickRefactor($this, false)
    });
  });

  $('.quick-product__btn').each(function() {
    let $this = $(this)
    $(this).on('click', function() {
      openQuickView($this)
    });
  })

  $('.hobo-go-plp__close-btn').each(function() {
    let $this = $(this)
    $(this).on('click', function() {
      closeQuickView($this);
    })
  });

  $('.mobile-cart__close').click(function() {
      $('.mobile-cart').animate({
          height: 'toggle',
          opacity: 'toggle'
      }, 500, function() { 
          $('.mobile-go-button').slideDown();
      });
  });

$('.mobile-go-button').click(function() {
        var $button = $(this); 

        $button.animate({
            height: 'toggle',
            opacity: 'toggle'
        }, 500, function() {
            $button.hide();
            $('.mobile-cart').slideDown('slow');
            var itemCount = fauxCart.items.length;
            var newText = ' - ' + itemCount + ' styles';
            $('.mobile-cart #styleCount').text(newText); 
        });
  });

  $('.hobo-go-plp__quickview__close-x').each(function() {
    let $this = $(this)
    $(this).on('click', function() {
      closeQuickView($this)
    })
  })

})